import { render, staticRenderFns } from "./SetCardsPriority.vue?vue&type=template&id=26437d72&"
import script from "./SetCardsPriority.vue?vue&type=script&lang=js&"
export * from "./SetCardsPriority.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports